import { render, staticRenderFns } from "./replyPopup.vue?vue&type=template&id=1c687850&scoped=true&"
import script from "./replyPopup.vue?vue&type=script&lang=js&"
export * from "./replyPopup.vue?vue&type=script&lang=js&"
import style0 from "./replyPopup.vue?vue&type=style&index=0&id=1c687850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c687850",
  null
  
)

export default component.exports